import React from "react";

const Tick = () => {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="120" height="120" rx="12" fill="#ECFDF3" />
      <path
        d="M72.0008 51.9992L56.0008 67.9992L48.0008 59.9992M64.9852 25.8352L69.869 29.9972C71.0994 31.0457 72.6272 31.6796 74.2387 31.8082L80.6348 32.318C84.3953 32.6181 87.3823 35.6032 87.6824 39.3637L88.191 45.7609C88.3196 47.3724 88.9558 48.9024 90.0043 50.1328L94.1645 55.0153C96.6113 57.8866 96.6117 62.1101 94.1648 64.9814L90.0047 69.8647C88.9561 71.0951 88.3208 72.6256 88.1922 74.2371L87.6805 80.6333C87.3804 84.3938 84.398 87.3808 80.6375 87.6809L74.2391 88.1914C72.6276 88.32 71.0984 88.9523 69.868 90.0008L64.9852 94.1629C62.1139 96.6098 57.8877 96.6103 55.0164 94.1634L50.1336 90.0012C48.9032 88.9526 47.374 88.3192 45.7625 88.1906L39.3641 87.6809C35.6035 87.3808 32.6212 84.3945 32.3211 80.634L31.8094 74.2375C31.6808 72.626 31.0454 71.0968 29.9969 69.8664L25.8367 64.9817C23.3898 62.1104 23.3887 57.8881 25.8356 55.0168L29.9995 50.132C31.048 48.9016 31.6773 47.3724 31.8059 45.761L32.3176 39.3645C32.6177 35.6039 35.6086 32.6177 39.3692 32.3176L45.7605 31.8078C47.372 31.6792 48.902 31.0458 50.1324 29.9973L55.0168 25.8352C57.8881 23.3883 62.1139 23.3883 64.9852 25.8352Z"
        stroke="#027A48"
        stroke-width="8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Tick;
